import { $httpAuth } from '@/services/http-common'

export default {
  createOrganizationConnection (orgId, code, type) {
    return $httpAuth.post(`api/organizations/${orgId}/connections?type=${type}`, {
      code
    })
  },
  getOrganizationConnections (orgId) {
    return $httpAuth.get(`api/organizations/${orgId}/connections`)
  },
  getOrganizationPages (orgId) {
    return $httpAuth.get(`/api/organizations/${orgId}/pages`)
  }
}
